// startup
// Load entry module and return exports
__webpack_require__("./src/wp-content/themes/backpress/assets/src/js/theme.js");
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = __webpack_require__("./src/wp-content/themes/backpress/assets/src/css/theme.scss");
